import { useInfiniteQuery } from "react-query";
import { useContext } from "react";
import { AuthContext } from "../../Context/AuthContext";

const getAllConcerns = async ({ pageParam = 1, token }) => {
  const response = await fetch(
    `${process.env.REACT_APP_SERVER_URL}/raise/get-concerns?page=${pageParam}`,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    }
  );

  if (!response.ok) {
    throw new Error("Failed to fetch all concerns");
  }

  return response.json();
};

const useFetchAllConcerns = () => {
  const { token } = useContext(AuthContext);

  return useInfiniteQuery(
    ["allConcerns"],
    ({ pageParam = 1 }) => getAllConcerns({ pageParam, token }),
    {
      getNextPageParam: (lastPage) => {
        const { currentPage, totalConcerns } = lastPage;
        const totalPages = Math.ceil(totalConcerns / 10);
        return currentPage < totalPages ? currentPage + 1 : undefined;
      },
      keepPreviousData: true,
    }
  );
};

export default useFetchAllConcerns;
